import React, { memo } from 'react';

const BreakdownSegment = memo(({
  label,
  value,
  hideIfZero = false,
  isAlertCard,
  variant = 'compact',
  textSize = 'text-xs',
  accent = false,
}) => {
  if (value === undefined || value === null) return null;
  if (hideIfZero && value === 0) return null;

  const isExpanded = variant === 'expanded';
  const spacingCls = isExpanded ? 'mb-1.5 pb-1' : 'mb-0.5 pb-0.5';
  const borderCls = isAlertCard ? 'border-white/20' : 'border-gray-200';
  const labelCls = accent
    ? (isAlertCard ? 'text-white font-medium' : 'text-red-600 font-medium')
    : (isAlertCard ? 'text-white' : isExpanded ? 'text-gray-700' : 'text-gray-600');
  const valueCls = accent
    ? (isAlertCard ? 'text-white' : 'text-red-600')
    : (isAlertCard ? 'text-white' : 'text-gray-900');

  return (
    <div className={`flex items-center justify-between ${textSize} ${spacingCls} border-b ${borderCls}`}>
      <div className="flex items-center min-w-0 flex-1">
        <span className={`truncate ${labelCls}`}>{label}</span>
      </div>
      <span className={`font-semibold ml-2 flex-shrink-0 ${valueCls}`}>{value}</span>
    </div>
  );
});

BreakdownSegment.displayName = 'BreakdownSegment';
export default BreakdownSegment;
